import { isBrowser } from "@montana/helpers/browser.helper";

const sessionStorageAvailable = isBrowser && window.sessionStorage !== undefined;


export const setSessionStorageItem = (key: string, value: string): void => {
    if (sessionStorageAvailable) {
        window.sessionStorage.setItem(key, value);
    }
};

export const getSessionStorageItem = (key: string): string | null => {
    if (sessionStorageAvailable) {
        return window.sessionStorage.getItem(key);
    }

    return null;
};

export const removeSessionStorageItem = (key: string): void => {
    if (sessionStorageAvailable) {
        window.sessionStorage.removeItem(key);
    }
};
